import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AutoSearch from '../AutoSearch/AutoSearch';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { SetQuery } from '../../actions';
import { gaEvent, xlt } from '../../utils/utils';
import styles from './HomepageCaribbean.css';
import withStyles from '../../decorators/withStyles';


class HomepageCaribbean extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchVal: props.q,
      componentKey: 0,
      idbLogo: "/static/idb_transparent_back.png"
    };
  }

  componentWillMount() {
    document.body.style.background = 'no-repeat url("/static/water_1920.jpg") #4b6186';
    document.body.style["background-size"] = 'cover';
  }

  componentWillUnmount() {
    document.body.style.background = '';
  }

  componentDidMount() {
    d3.select("#tx-live-lang-container li[data-value='bn']").style("display", "none");
    Transifex.live.onBeforeTranslatePage(() => {
      this.setState({componentKey: this.state.componentKey === 0 ? 1 : 0});
    });
    Transifex.live.onAfterTranslate(() => {
      if (Transifex.live.getSelectedLanguageCode() === "es") {
        this.setState({idbLogo: "/static/idb_transparent_back_esp.png"})
      } else {
        this.setState({idbLogo: "/static/idb_transparent_back.png"})
      }
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.dispatch(SetQuery(this.state.searchVal));
    browserHistory.push({pathname: "/search", query: {q: this.state.searchVal}, state: {...this.props, q: this.state.searchVal}});
  };

  render() {
    const scope = this.props.routes[this.props.routes.length - 1].path.slice(1);
    return (
      <div className="homepage-header">
        <div className="rising-seas">
          <nav className={"Header row nav " + (this.props.mobileMenuOpen ? "menu-open" : "")}>

            <div className="left-icon">
              <Link to={{pathname: "/about", state: {modal: true, homepage: true, modalTitle: "About this site", returnTo: location.pathname}}}>
                <button className="type-small nav-btn about-btn" data-navtarget="theaboutpage" data-paneltype="modal" data-gaq="Click:Nav:About" title="Learn about this map">
                  <span className="white icon info"></span>
                  <span className="small-screen">Learn about this map</span>
                </button>
              </Link>
            </div>

            <div className="">
              <h1 style={{"textAlign": "center"}}>
                <div className="logo-container">
                  <a className="logo-link--main" href="/">
                    <img className="logo-svg" src={require("../../public/logo-surging-seas-blue.svg")}/>
                  </a>
                  <a className="logo-link--sec" href="/">
                    <span>Risk Finder</span>
                  </a>
                </div>
              </h1>
            </div>

            <div className="right-icon">
              <a href="https://twitter.com/intent/tweet?text=See%20your%20local%20sea%20level%20and%20coastal%20flood%20risk%20on%20our%20Surging%20Seas%20Risk%20Finder%20tool&via=ClimateCentral&url=http://www.riskfinder.org" target="_blank"
              >
                <img className="nav-btn" src="/static/Twitter_Logo.svg" style={{width: 45, display: "inline"}}
                     onClick={() => {gaEvent('navlink', 'click', 'twitter');}}
                />
              </a>
              <a href="https://www.facebook.com/sharer.php?p%5Burl%5D=http://www.riskfinder.org/" target="_blank">
                <img className="nav-btn" src="/static/F_icon.svg"
                     onClick={() => {gaEvent('navlink', 'click', 'facebook');}}
                     style={{width: 25, marginLeft: 12, marginRight: 6, display: "inline"}}
                />
              </a>
            </div>
          </nav>
        </div>

        <div className="HomepageCaribbean">
          <main>
            <section>
              <div className="title-block">
                <h1>Explore sea level and coastal flood risks</h1>
                <h1>in the Caribbean basin</h1>
              </div>
              <AutoSearch
                  nav={false}
                  autofocus={true}
                  placeholder={xlt("Enter a country, parish or other district*")}
                  scope={scope}
              />
              <div className="links">
                <Link to={{pathname: "/about", state: {modal: true, caribbeanHomepage: true, modalTitle: "About this site", returnTo: location.pathname}}}>
                  About this project
                </Link>
                  {/*
                  <a href="#" target="_blank"
                   onClick={e => e.preventDefault() && gaEvent('searchlink-about', 'click', 'homepage')}>About this project</a>
                   */}
                <a href="https://www.youtube.com/watch?v=l5mw2FSaf_s" target="_blank"
                   onClick={() => gaEvent('video-link', 'click', 'homepage')}>Video tutorial</a>
              </div>
              <div className="details">
                <div className="geography-text">
                  *Geography included: Antigua and Barbuda, Barbados, Corn Island (Nicaragua), Dominica, Dominican Republic,
                  Grenada, Guyana, Haiti, Jamaica, Suriname, Trinidad and Tobago, St. Kitts and Nevis, St. Lucia,
                  St. Vincent and the Grenadines, San Blas (Panama), The Bahamas
                </div>
                <div className="logo-container">
                  <img className="cc-logo" src="/static/cc_logo_stacked_flat.png" />
                  <img className="idb-logo" src={this.state.idbLogo} />
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    );
  }

}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(HomepageCaribbean);
